import $ from "jquery";

import Backdraft from "backdraft-app/src/backdraft";
import _ from "underscore";

Backdraft.app("Shared/SignalExpression", function(app) {
  app.collection("Keywords", {

    model: app.Models.Keyword,

    stats: function() {
      this.trimAllNames();
      var nonBlank = _.reject(this.models, function(key) { return $.trim(key.get('name')) === ''; }),
        unique   = _.unique(_.map(nonBlank, function(key) { return JSON.stringify(key); }));
      return {
        unique: unique,
        allUnique: (nonBlank.length === unique.length)
      };
    },

    invalidPhrases: function() {
      return _.filter(this.pluck('name'), function(key) { return /[\|]/.test(key); });
    },

    allPhrases: function() {
      var keywords = _.reject(this.models, function(keyObj) { return $.trim(keyObj.get('name')) === ''; });
      return keywords.map(function(keyObj) {
        var name    = $.trim(keyObj.get('name')),
          speaker = (keyObj.get('speaker') != "Agent or Caller") ? '|' + keyObj.get('speaker') : '';
        return name + speaker;
      });
    },

    trimAllNames: function() {
      _.each(this.models, function(key) { key.trimName(); });
    },

    formattedList: function() {
      var keywords = _.reject(this.models, function(keyObj) { return $.trim(keyObj.get('name')) === ''; });
      return keywords.map(function(keyObj) {
        var name    = $.trim(keyObj.get('name')),
          speaker = ' (' + keyObj.get('speaker') + ')';
        return name + speaker;
      });
    },

    canDelete: function() {
      if (this.length > 1) {
        return true;
      } else {
        return false;
      }
    }
  });
});
